import { matchPath } from 'react-router';
import { RoutePath } from 'features/routing/constants';
import { isStoredSessionStale } from './lastActivity';

type AppRenderState = {
  isAuthenticated: boolean;
  pathname: string;
  isLoggingOut: boolean;
};

// The router decodes each segment before matching, keeping an encoded slash.
const decodeSegments = (pathname: string): string => {
  try {
    return pathname
      .split('/')
      .map(segment => decodeURIComponent(segment).replaceAll('/', '%2F'))
      .join('/');
  } catch {
    return pathname;
  }
};

/** Whether `pathname` matches `pattern` as the router matches it. */
export const matchesRoute = (pattern: string, pathname: string): boolean =>
  matchPath(pattern, decodeSegments(pathname)) !== null;

export const isNoSessionRoute = (pathname: string): boolean =>
  matchesRoute(RoutePath.AuthCallback, pathname) ||
  matchesRoute(RoutePath.SignedOut, pathname);

/** A stale stored session counts on every page but the no-session routes,
 *  where a completing sign-in has not yet overwritten the stale mark. */
export const isPageSessionStale = (
  pathname: string = window.location.pathname
): boolean => !isNoSessionRoute(pathname) && isStoredSessionStale();

export const shouldRenderApp = ({
  isAuthenticated,
  pathname,
  isLoggingOut,
}: AppRenderState): boolean =>
  isAuthenticated || isNoSessionRoute(pathname) || isLoggingOut;
